module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Anchor-left-a7ec748874437cc96ff2a24686242a15.svg";